import { t } from '../../../i18n/uiText';

/**
 * Полноэкранная загрузка — тёплый paper + золотой индикатор (BibleFirst).
 */
export function BfPageLoader({ label, hint, className = '' }) {
  return (
    <div
      className={`bf-page-loader bf-app ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bf-page-loader__inner">
        <div className="bf-page-loader__mark" aria-hidden="true">
          <span className="bf-page-loader__ring" />
        </div>
        <p className="bf-page-loader__label">{label ?? t('loading')}</p>
        {hint ? <p className="bf-page-loader__hint">{hint}</p> : null}
      </div>
    </div>
  );
}

/**
 * Компактная загрузка внутри листа / модалки.
 */
export function BfInlineLoader({ label, hint, className = '' }) {
  return (
    <div
      className={`bf-inline-loader ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bf-page-loader__mark bf-page-loader__mark--sm" aria-hidden="true">
        <span className="bf-page-loader__ring" />
      </div>
      {label ? <p className="bf-inline-loader__label">{label}</p> : null}
      {hint ? <p className="bf-inline-loader__hint">{hint}</p> : null}
    </div>
  );
}
